module.exports = __webpack_public_path__ + "img/endLottery.3b56f98c.png";